<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 23 30"
    :width="width"
    :height="height"
    class="task-template-icon"
    :style="{ '--icon-color': color }"
    fill="none"
  >
    <g clip-path="url(#task-template-icon-clip)">
      <path
        d="M19.465 3.70761H14.8304C14.8304 1.66263 13.1678 0 11.1228 0C9.07785 0 7.41522 1.66263 7.41522 3.70761H2.78071C1.24553 3.70761 0 4.95314 0 6.48832V26.8802C0 28.4154 1.24553 29.6609 2.78071 29.6609H19.465C21.0001 29.6609 22.2457 28.4154 22.2457 26.8802V6.48832C22.2457 4.95314 21.0001 3.70761 19.465 3.70761ZM11.1228 2.31726C11.8933 2.31726 12.5132 2.93713 12.5132 3.70761C12.5132 4.4781 11.8933 5.09797 11.1228 5.09797C10.3523 5.09797 9.73248 4.4781 9.73248 3.70761C9.73248 2.93713 10.3523 2.31726 11.1228 2.31726ZM18.1441 15.7458L9.85993 23.9605C9.58765 24.2327 9.14737 24.2269 8.87509 23.9547L4.08996 19.129C3.81768 18.8567 3.82347 18.4164 4.09575 18.1441L5.741 16.5105C6.01328 16.2382 6.45356 16.244 6.72584 16.5163L9.39068 19.2043L15.5314 13.1099C15.8037 12.8376 16.244 12.8434 16.5162 13.1157L18.1499 14.7609C18.4222 15.039 18.4164 15.4735 18.1441 15.7458Z"
        fill="currentColor"
      />
    </g>
    <defs>
      <clipPath id="task-template-icon-clip">
        <rect width="22.2457" height="29.6609" fill="white" />
      </clipPath>
    </defs>
  </svg>
</template>

<script setup>
defineProps({
  width: {
    type: [String, Number],
    default: 18,
  },
  height: {
    type: [String, Number],
    default: 24,
  },
  color: {
    type: String,
    default: '#333',
  },
})
</script>

<style scoped>
.task-template-icon {
  display: inline-block;
  vertical-align: middle;
  color: var(--icon-color, #333);
  transition: opacity 0.2s;
}

.task-template-icon:hover {
  opacity: 0.8;
}
</style>

<style>
button.template-picker-button .task-template-icon {
  color: inherit;
}
</style>
